<template>
  <div class="page-header">
    <div class="header-wrapper">
      <img alt="Cover picture" :src="cover">
      <div class="overlay-mask"></div>
    </div>
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    msg: String,
    cover: String
  }
}
</script>

<style scoped lang="sass">
.page-header
  width: 100%
  height: 240px
  .header-wrapper
    overflow: hidden
    height: 100%
    position: relative
    img
      width: 100%
      height: 100%
      object-fit: cover

      position: absolute
      z-index: 1
      width: 100%
      height: 100%
      top: 0
      left: 0
    .overlay-mask
      background: rgba(0, 0, 0, .6)
      position: absolute
      z-index: 2
      width: 100%
      height: 100%
      top: 0
      left: 0
</style>
